var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        { staticClass: "card-container", attrs: { shadow: "hover" } },
        [
          _c("app-divider", {
            staticClass: "margin-bottom",
            attrs: { label: "Dados do VTN: ", addMarginTop: false }
          }),
          _c(
            "div",
            { staticClass: "center" },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c("app-label", {
                        staticClass: "appLabel",
                        attrs: { label: "Área requerida (ha):", required: true }
                      }),
                      _c("validation-provider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var errors = ref.errors
                              return [
                                _c("app-double-input", {
                                  staticClass: "appInput",
                                  attrs: {
                                    hasValidationError: errors.length > 0,
                                    name: "Área",
                                    precision: 4,
                                    onkeypress: _vm.onlyInputNumbers
                                  },
                                  model: {
                                    value: _vm.vtnRequest.areaRequerida,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.vtnRequest,
                                        "areaRequerida",
                                        $$v
                                      )
                                    },
                                    expression: "vtnRequest.areaRequerida"
                                  }
                                }),
                                _c("span", { staticClass: "help erro" }, [
                                  _vm._v(_vm._s(errors[0]))
                                ])
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c("app-label", {
                        staticClass: "appLabel",
                        attrs: { label: "Munícipio:", required: true }
                      }),
                      _c("el-input", {
                        attrs: { disabled: true },
                        model: {
                          value: _vm.vtnRequest.municipio.nome,
                          callback: function($$v) {
                            _vm.$set(_vm.vtnRequest.municipio, "nome", $$v)
                          },
                          expression: "vtnRequest.municipio.nome"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c("validation-provider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var errors = ref.errors
                              return [
                                _c("app-label", {
                                  staticClass: "appLabel",
                                  attrs: { label: "Nível:", required: true }
                                }),
                                _c(
                                  "el-select",
                                  {
                                    class: { erro: errors.length },
                                    model: {
                                      value: _vm.vtnRequest.nivel,
                                      callback: function($$v) {
                                        _vm.$set(_vm.vtnRequest, "nivel", $$v)
                                      },
                                      expression: "vtnRequest.nivel"
                                    }
                                  },
                                  _vm._l(_vm.niveis, function(nivel) {
                                    return _c("el-option", {
                                      key: nivel.codigo,
                                      attrs: {
                                        label: nivel.nome,
                                        value: nivel.codigo
                                      }
                                    })
                                  }),
                                  1
                                ),
                                _c("span", { staticClass: "help erro" }, [
                                  _vm._v(_vm._s(errors[0]))
                                ])
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c("app-label", {
                        staticClass: "appLabel",
                        attrs: {
                          label: "Valor de referência/Ha:",
                          required: true
                        }
                      }),
                      _c(
                        "div",
                        {
                          staticClass:
                            "el-input-group el-input-group--prepend appInput"
                        },
                        [
                          _c("app-double-input", {
                            attrs: {
                              name: "valorReferencia",
                              precision: 2,
                              onkeypress: _vm.onlyInputNumbers,
                              disable: true
                            },
                            model: {
                              value: _vm.valorReferencia,
                              callback: function($$v) {
                                _vm.valorReferencia = $$v
                              },
                              expression: "valorReferencia"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c("app-label", {
                        staticClass: "appLabel",
                        attrs: { label: "VTN:", required: true }
                      }),
                      _c(
                        "div",
                        {
                          staticClass:
                            "el-input-group el-input-group--prepend appInput"
                        },
                        [
                          _c("app-double-input", {
                            attrs: {
                              name: "valorVtn",
                              precision: 2,
                              onkeypress: _vm.onlyInputNumbers,
                              disable: true
                            },
                            model: {
                              value: _vm.valorVtn,
                              callback: function($$v) {
                                _vm.valorVtn = $$v
                              },
                              expression: "valorVtn"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c("app-label", {
                        staticClass: "appLabel",
                        attrs: {
                          label: "Valor de referência do imóvel:",
                          required: true
                        }
                      }),
                      _c(
                        "div",
                        {
                          staticClass:
                            "el-input-group el-input-group--prepend appInput"
                        },
                        [
                          _c("app-double-input", {
                            attrs: {
                              name: "valorReferenciaImovel",
                              precision: 2,
                              onkeypress: _vm.onlyInputNumbers,
                              disable: true
                            },
                            model: {
                              value: _vm.valorReferenciaImovel,
                              callback: function($$v) {
                                _vm.valorReferenciaImovel = $$v
                              },
                              expression: "valorReferenciaImovel"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "center" },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-checkbox",
                    {
                      model: {
                        value: _vm.vtnRequest.taxaDiversa,
                        callback: function($$v) {
                          _vm.$set(_vm.vtnRequest, "taxaDiversa", $$v)
                        },
                        expression: "vtnRequest.taxaDiversa"
                      }
                    },
                    [_vm._v("Taxas diversas (10% do valor do VTN)")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-11796c18", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11796c18","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/vtn/components/InformarDadosMa.vue
// module id = null
// module chunks = 